export const imgTxtXML = `
<?xml version="1.0" encoding="utf-8"?>
<msg brief="企点结构化消息" serviceID="115" background="#FFFFFFFF" action="web" actionData="https://qq.com">
<linear background="#FFFFFFFF" width="-2" height="-2" orientation="vertical">
<linear width="-2" height="-2" margin="20,16,20,12" margin.pc="10,8,10,6" orientation="vertical">
<linear width="-2" height="-2" margin="0,8,0,8" margin.pc="0,4,0,4" gravity="left|centerVertical">
<text height="-2" width="420" size="28" color="#FF1E2330" width.pc="210" size.pc="10" color.pc="0xFF1E2330" maxLine="1" text="小鹿" gravity="left|centerVertical"></text>
</linear>
<linear width="-2" height="-2">
<image width="420" height="328" width.pc="210" height.pc="164" cornerRadius="0" src="http://eamaterial-30012.picsz.qpic.cn/material/image/2852199661_4ecf237221a7728bda4013a801edfdb6"></image>
</linear>
<linear width="0" height="0" >
<text size="28" color="#FF1E2330" maxLine="1" text="wxc0f12af109cd1049"></text>
<text size="28" color="#FF1E2330" maxLine="1" text="pages/realname/realname"></text>
</linear>
<linear background="#FFE1E6F0" width="420" height="2" margin="0,18,0,6" width.pc="210" height.pc="1" margin.pc="0,9,0,3">
</linear>
<linear width="-2" height="-2">
<image width="24" height="24" width.pc="12" height.pc="12" cornerRadius="0" src="https://oa.gtimg.com/demo/sdk/flex_pic/basic/pic4@3x.png"></image>
<text height="-2" width="380" margin="6,0,0,0" size="28" color="#FFA1ABC2" lineSpace="14" width.pc="190" margin.pc="3,0,0,0" size.pc="8" color.pc="0xA1ABC2" text="上限啊啊啊啊啊啊啊啊啊啊啊啊啊" maxLine="1"></text>
</linear>
</linear>
</linear>
</msg>
`;
